// extracted by mini-css-extract-plugin
export default {"navbar":"Sidebar_navbar__DL0uS","navMenu":"Sidebar_navMenu__hZSXh","active":"Sidebar_active__8Rvdk","navClose":"Sidebar_navClose__WVEMg","navLinks":"Sidebar_navLinks__Dwv6P"};